import PropTypes from 'prop-types';
import classnames from 'classnames';

import { ReactComponent as ArrowRightSVG } from 'icons/arrow-right-small.svg';
import { ReactComponent as ArrowLeftSVG } from 'icons/arrow-left-small.svg';

const Toolbar = ({ label, view, onNavigate, onView }) => {
  const carryingHandleActionClick = (action) => () => onNavigate(action);
  const carryingHandleViewClick = (view) => () => onView(view);

  const monthClasses = classnames('th-btn th-btn-whitegrey', {
    'th-btn-active': view === 'month',
  });
  const weekClasses = classnames('th-btn th-btn-whitegrey', {
    'th-btn-active': view === 'week',
  });
  const dayClasses = classnames('th-btn th-btn-whitegrey', {
    'th-btn-active': view === 'day',
  });

  return (
    <div className="th-calendar-toolbar">
      <div className="th-toolbar-views flex">
        <div className="th-btn-group">
          <button
            className="th-btn th-btn-whitegrey"
            onClick={carryingHandleActionClick('PREV')}
          >
            <ArrowLeftSVG />
          </button>
          <button
            className="th-btn th-btn-whitegrey"
            onClick={carryingHandleActionClick('NEXT')}
          >
            <ArrowRightSVG />
          </button>
        </div>
        <button
          className="th-btn th-btn-whitegrey ml10"
          onClick={carryingHandleActionClick('TODAY')}
        >
          Today
        </button>
      </div>
      <span className="th-toolbar-label">{label}</span>
      <div className="th-toolbar-views th-btn-group">
        <button
          className={monthClasses}
          onClick={carryingHandleViewClick('month')}
        >
          Month
        </button>
        <button
          className={weekClasses}
          onClick={carryingHandleViewClick('week')}
        >
          Week
        </button>
        <button className={dayClasses} onClick={carryingHandleViewClick('day')}>
          Day
        </button>
      </div>
    </div>
  );
};

Toolbar.propTypes = {
  label: PropTypes.string,
  view: PropTypes.string,
  onNavigate: PropTypes.func,
  onView: PropTypes.func,
};

export default Toolbar;
